import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './PrescriptionDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import PillDetailInformBox from '../../../../components/box/PillDetailInformBox';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { BottomSheet } from 'react-spring-bottom-sheet';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import 'react-spring-bottom-sheet/dist/style.css';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDateWithWeekday } from '../../../../assets/js/comm';

import Skeleton from '@mui/material/Skeleton';

const PrescriptionDetail = () => {

    const [mediInfo, setMediInfo] = useState();
    const [clnicMedPrscInfo, setClnicMedPrscInfo] = useState({});
    const [clnicMedPrscList, setClnicMedPrscList] = useState([]);
    const [clnicMedPrscTkmdcnTmList, setClnicMedPrscTkmdcnTmList] = useState([]);
    const [clnicMedDtlInfo, setClnicMedDtlInfo] = useState({
        hsptlCd : "",
        mdctnNo : ""
    });

    const [subType, setSubType] = useState("drugZone");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    const { hsptlCd = "", patntId = "", deptCd = "", treatYmd = "" } = location.state || {};

    useEffect(() => {
        getClnicInfo();
    }, []);

    const getClnicInfo = useCallback(async () => {

        setIsLoading(true);

        const url = "/hsptl/retrieveHsptlClnicMedPrscInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            deptCd: deptCd,
            treatYmd : treatYmd
        }

        //prscrptnDt

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            //console.log(res.data.resultCode)
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                
                setMediInfo({...mediInfo});
                setClnicMedPrscInfo(mediInfo.clnicMedPrscInfo);
                setClnicMedPrscList(mediInfo.clnicMedPrscList);
                setClnicMedPrscTkmdcnTmList(mediInfo.clnicMedPrscTkmdcnTmList);

                console.log("mediInfo.clnicMedPrscTkmdcnTmList : ", mediInfo.clnicMedPrscTkmdcnTmList)

                
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [navigate]);




    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const formatPrescriptionDates = (dateString) => {
        if (!dateString) return "데이터 없음";
        
        try {
            const dateArray = dateString.split(",")
                .map(date => date.trim())
                .filter(date => date);
            
            return dateArray.map((date, index) => (
                <span key={index}>
                    {formatDateWithWeekday(date)}
                    {index < dateArray.length - 1 && ", "}
                </span>
            ));
        } catch (error) {
            console.error("날짜 처리 오류:", error);
            return "날짜 형식 오류";
        }
    };

    return (
        <>
            <HeadSub title="처방 상세"/>

            <div id="sub-content">
                <div className='inner-wrap' data-bg-color="white" data-pad="normal">
                    
                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>기본정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>처방일자</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>
                                            {formatPrescriptionDates(clnicMedPrscInfo?.prscrptnDt)}
                                        </span>
                                        )}
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{clnicMedPrscInfo.deptNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{clnicMedPrscInfo.doctrNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>처방 건수</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="40px" height={20} />
                                        ) : (
                                        <span>{clnicMedPrscInfo.totalCount}건</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>처방 일수</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="40px" height={20} />
                                        ) : (
                                        <span>{clnicMedPrscInfo.totDays}일</span>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>처방 정보</h2>
                            <Box sx={{ display: "flex" }} className={style["swich-btn-btn"]}>
                                <Box className={"mask-box"}>
                                    <Box className="mask" style={{transform: `translateX(${subType === "drugZone" ? 0 : "var(--sp-wid-86)"})`}}/>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "drugZone" ? "#ffffff !important;" : "var(--color-main-gray-10)"}}
                                        onClick={() => setSubType("drugZone")}
                                        className={subType === "drugZone" ? `${style.active}` : null}
                                    >
                                        약품별
                                    </Button>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "timeZone" ? "#ffffff" : "var(--color-main-gray-10)"}}
                                        onClick={() => setSubType("timeZone")}
                                        className={subType === "timeZone" ? `${style.active}` : null}
                                        >
                                        복용시간대별
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                    </div>
                </div>


                <div className='inner-wrap' data-pad="normal">


                    {subType === "drugZone" ? (
                        
                            //약품별별
                            <div className={style["detail-list-box"]}>
                            <ul> 
                             
                            {isLoading ? (
                                        <li>
                                            <div className={style["list-box"]}>
                                                <div className={style["head"]}>
                                                    <Skeleton variant="text" width={180} height={24} />
                                                </div>
                                                <p className={style["take-day"]}>
                                                <Skeleton variant="text" width={80} height={20} />
                                                </p>
                                                <p className={style["take-date"]}>
                                                    <Skeleton variant="text" width={120} height={20} />
                                                </p>
                                                <p className={style["take-amount"]}>
                                                    <Skeleton variant="text" width={100} height={20} />
                                                </p>
                                            </div>
                                        </li>
                                        ) : (
                                clnicMedPrscList.map((item, index) => {               
                                    return(
                                    <li>
                                        <div className={style["list-box"]} onClick={() => {
                                            setClnicMedDtlInfo({
                                                hsptlCd : item.hsptlCd      ,
                                                mdctnNo : item.prscrptnCd
                                            })
                                            setOpen(true)
                                        }}>
                                            <div className={style["head"]}>
                                                <strong>{item.prscrptnNm}</strong>
                                            </div>
                                            <p className={style["take-day"]}>
                                            <span>{item.admnstrtnNm2}</span>
                                            <span>{item.admnstrtnNm3}</span>
                                            </p>
                                            <p className={style["take-date"]}>
                                                <span>총 {item.totDays}일</span>
                                                <span>{item.admnstrtn}</span>
                                            </p>
                                            <p className={style["take-amount"]}>
                                                {item.dailyFrqncy}회 투약량 {item.doseAmt}개
                                            </p>
                                        </div>
                                    </li>
                                    )                 
                                })
                            )}
                            {/* 
                                <li>
                                    <div className={style["list-box"]} onClick={() => setOpen(true)}>
                                        <div className={style["head"]}>
                                            <strong>가스터정 20mg</strong>
                                        </div>
                                        <p className={style["take-day"]}>
                                        <span>아침/저녁</span>
                                        <span>식후 30분 이내 복용</span>
                                        </p>
                                        <p className={style["take-date"]}>
                                            <span>총 5일</span>
                                            <span>하루 2회 복용</span>
                                        </p>
                                        <p className={style["take-amount"]}>
                                            1회 투약량 1개
                                        </p>
                                    </div>
                                </li>
                            */}
                            </ul>   
                        </div>
                    ): (

                        //처방시간대별
                        <div className={style["detail-list-box"]} data-type="b">
                            <ul> 

                            {
                                    (()=>{
                                        const filteredList = clnicMedPrscTkmdcnTmList.filter(item => item.admnstrtnNm2 === '아침');
                                        if(filteredList.length > 0){
                                            return (
                                                <li>
                                                    <div className={style["list-box"]}>
                                                        <div className={style["top-head"]}>
                                                            <span data-day-i="1">아침</span>
                                                        </div>
                                                        <div className={style["days-list-box"]}>
                                                            <ul>
                                                                {
                                                                    clnicMedPrscTkmdcnTmList.map((item, index) => {
                                                                        if(item.admnstrtnNm2 === '아침'){
                                                                            return (
                                                                                <li>
                                                                                    <strong>{item.totDays}일치</strong>
                                                                                    <span>{item.prscrptnNm}</span>
                                                                                </li>        
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>            
                                            )
                                        }
                                    })()
                                }

{
                                    (()=>{
                                        const filteredList = clnicMedPrscTkmdcnTmList.filter(item => item.admnstrtnNm2 === '점심');
                                        if(filteredList.length > 0){
                                            return (
                                                <li>
                                                    <div className={style["list-box"]}>
                                                        <div className={style["top-head"]}>
                                                            <span data-day-i="2">점심</span>
                                                        </div>
                                                        <div className={style["days-list-box"]}>
                                                            <ul>
                                                                {
                                                                    clnicMedPrscTkmdcnTmList.map((item, index) => {
                                                                        if(item.admnstrtnNm2 === '점심'){
                                                                            return (
                                                                                <li>
                                                                                    <strong>{item.totDays}일치</strong>
                                                                                    <span>{item.prscrptnNm}</span>
                                                                                </li>        
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>            
                                            )
                                        }
                                    })()
                                }

                                {
                                    (()=>{
                                        const filteredList = clnicMedPrscTkmdcnTmList.filter(item => item.admnstrtnNm2 === '저녁');
                                        if(filteredList.length > 0){
                                            return (
                                                <li>
                                                    <div className={style["list-box"]}>
                                                        <div className={style["top-head"]}>
                                                            <span data-day-i="3">저녁</span>
                                                        </div>
                                                        <div className={style["days-list-box"]}>
                                                            <ul>
                                                                {
                                                                    clnicMedPrscTkmdcnTmList.map((item, index) => {
                                                                        if(item.admnstrtnNm2 === '저녁'){
                                                                            return (
                                                                                <li>
                                                                                    <strong>{item.totDays}일치</strong>
                                                                                    <span>{item.prscrptnNm}</span>
                                                                                </li>        
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>            
                                            )
                                        }
                                    })()
                                }

                                {
                                    (()=>{
                                        const filteredList = clnicMedPrscTkmdcnTmList.filter(item => item.admnstrtnNm2 === '기타');
                                        if(filteredList.length > 0){
                                            return (
                                                <li>
                                                    <div className={style["list-box"]}>
                                                        <div className={style["top-head"]}>
                                                            <span data-day-i="4">기타</span>
                                                        </div>
                                                        <div className={style["days-list-box"]}>
                                                            <ul>
                                                                {
                                                                    clnicMedPrscTkmdcnTmList.map((item, index) => {
                                                                        if(item.admnstrtnNm2 === '기타'){
                                                                            return (
                                                                                <li>
                                                                                    <strong>{item.totDays}일치</strong>
                                                                                    <span>{item.prscrptnNm}</span>
                                                                                </li>        


)
                                                                        }
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>            
                                            )
                                        }
                                    })()
                                }


                                {/*
                                <li>
                                    <div className={style["list-box"]}>
                                        <div className={style["top-head"]}>
                                            <span data-day-i="1">아침</span>
                                        </div>
                                        <div className={style["days-list-box"]}>
                                            <ul>
                                                <li>
                                                    <strong>1일치</strong>
                                                    <span>타이레놀정</span>
                                                </li>
                                                <li>
                                                    <strong>5일치</strong>
                                                    <span>가스터정 20mg, 가스모틴정 5mg, 우루사정 200mg, 아크로펜정 100mg, 가스터정 20mg, 가스모틴정 5mg, 우루사정 200mg, 아크로펜정 100mg</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={style["list-box"]}>
                                        <div className={style["top-head"]}>
                                            <span data-day-i="2">점심</span>
                                        </div>
                                        <div className={style["days-list-box"]}>
                                            <ul>
                                                <li>
                                                    <strong>5일치</strong>
                                                    <span>가스터정 20mg, 가스모틴정 5mg,</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={style["list-box"]}>
                                        <div className={style["top-head"]}>
                                            <span data-day-i="3">저녁</span>
                                        </div>
                                        <div className={style["days-list-box"]}>
                                            <ul>
                                                <li>
                                                    <strong>1일치</strong>
                                                    <span>타이레놀정</span>
                                                </li>
                                                <li>
                                                    <strong>5일치</strong>
                                                    <span>가스터정 20mg, 가스모틴정 5mg, 우루사정 200mg, 아크로펜정 100mg, 가스터정 20mg, 가스모틴정 5mg, 우루사정 200mg, 아크로펜정 100mg</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                */}
                            </ul>   
                        </div>
                    )}
                    
                </div>

                <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                         >
                            <PillDetailInformBox 
                                key={`${clnicMedDtlInfo.hsptlCd}_${clnicMedDtlInfo.mdctnNo}`} // 고유값 지정
                                hsptlCd={clnicMedDtlInfo.hsptlCd} 
                                mdctnNo={clnicMedDtlInfo.mdctnNo} 
                                onClose={onDismiss} />
                </BottomSheet>


            </div>
            
        </>
    );
};

export default PrescriptionDetail;
